import React from 'react';
import { compose } from 'recompose';
import styled, { StylesProps } from '../../../lib/styles';
import { Brand } from '../../../lib/theme';

import cardBlockStyles from './CardBlock_styles';
import Spacer from '../../../components/presentational/Spacer';
import Typography from '../../../components/presentational/Typography';
import { Card } from '../../../models/travelCollection';
import Button from '../../../components/presentational/Button';

export interface CardBlocksProps {
  brand?: Brand;
  cards: Card[];
}

const CardBlocks = ({
  brand,
  styles,
  cards,
}: CardBlocksProps & StylesProps<typeof cardBlockStyles>) => (
  <Spacer align={'center'} space={'m'} className={styles.container}>
    <div className={styles.innerContainer}>
      {cards.map(({ title, description, buttonText, buttonURL }, i) => (
        <Spacer
          width={260}
          className={styles.card}
          space={'m'}
          align={'center'}
          justify={'space-between'}
          key={i}
        >
          <Spacer space={'s'} align={'center'}>
            <Typography brand={brand}>
              <h3>{title}</h3>
            </Typography>

            {description && (
              <Typography brand={brand}>
                <h4 dangerouslySetInnerHTML={{ __html: description }} />
              </Typography>
            )}
          </Spacer>

          {buttonText && <Button href={buttonURL}>{buttonText}</Button>}
        </Spacer>
      ))}
    </div>
  </Spacer>
);

export default compose(styled(cardBlockStyles))(CardBlocks);
